import {Component, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild, ElementRef, NgZone } from "@angular/core";
import { ExerciseResult, SkillTag, TagSource } from "src/app/modules/algebrakit/types/algebrakit.types";
import { Tag } from "src/app/modules/algebrakit/types/tags.types";

@Component({
    selector: "app-exercise-result",
    templateUrl: "./exercise-result.component.html",
    styleUrls: ["./exercise-result.component.less"],
    standalone: false
})
export class ExerciseResultComponent implements OnInit   {
    @Input() exerciseResult: ExerciseResult;

    correctTags: SkillTag[] = [];
    hintTags: SkillTag[] = [];
    errorTags: SkillTag[] = [];
    nextStepTags: SkillTag[] = [];
    
    progressPercentage(p:number) {
        return Math.round(p*100) + '%';
    }
    ngOnInit() {
        if(this.exerciseResult) {
            this.exerciseResult.questions
            .filter(_q => _q.interactions && _q.interactions.length>0)
            .forEach(_q => _q.interactions
                .filter(_inter => _inter.tags && _inter.tags.length>0)
                .forEach(_inter => 
                    _inter.tags.forEach(_tag => {
                        switch(_tag.source) {
                            case TagSource.ERROR_FEEDBACK:
                                this.errorTags.push(_tag);
                                break;
                            case TagSource.HINT:
                                this.hintTags.push(_tag);
                                break;
                            case TagSource.FINISHED_STEP:
                                this.correctTags.push(_tag)
                                break;
                            case TagSource.NEXT_STEP  :
                                this.nextStepTags.push(_tag);
                                break;  
                        }
                    })));

            
        }
    }
}
